import { broadcast, broadcastChannels } from './broadcast';

export const getNetworkTime = () => new Promise(resolve => {
    const onTimeChange = e => resolve(new Date(e.detail).getTime());
    broadcast.addEventListener(broadcastChannels.NetworkTimeChange, onTimeChange, { once: true });
    window.jsobject?.getNetworkTime?.();
});